import React, {useContext, useEffect} from 'react'
import {Modal} from '@mui/material'
import styled from 'styled-components'
import {Button} from 'common/button'
import {Text} from 'common/text'
import {FilterModalProduct} from './filter'
import {ProductTable} from './table'
import {sendRequestAuth} from '../../../../../../../api/api'
import config from '../../../../../../../config'
import {CreateTeacherContext} from '../../../provider/_context'
import {useCreateTeacherAction} from '../../../provider/_reducer'
import {useCreateProductAction, useModalProductAction} from '../../../provider/_action'
import {useParams, useSearchParams} from 'react-router-dom'
import {GLOBAL_ICONS} from "../../../../../../../interface/icon";
import {TAB_CREATE_TEACHER_EDIT} from "../../../interfaces/constant";

export const AddProductModal = ({open, data, onClose}) => {

   const {teacherId} = useParams()
   const {pageState, pageDispatch} = useContext(CreateTeacherContext)
   const [searchParams] = useSearchParams()
   const {productTab} = pageState
   const {table} = productTab
   const displayList = table?.display?.list

   useEffect(() => {
      if (searchParams.get('tab') === 'products')
         pageDispatch({ type: useCreateTeacherAction.FORM_CREATE_TAB_CHANGE, payload: TAB_CREATE_TEACHER_EDIT[1] })
   }, [searchParams])
   
   const getProductList = async () => {

      const response = await Promise.all([
         sendRequestAuth('get', `${config.API}/principal/teacher/products/${teacherId}?keyword&category_id&status&start=0&per_page=20`),
         sendRequestAuth('get', `${config.API}/principal/teacher/filter-products/${teacherId}?keyword=&category_id=&status=&per_page=200&start=`)
      ])
      if(response?.[0]?.data?.success) {
         pageDispatch({
               type: useCreateProductAction.TABLE_LOADING_DISPLAY,
               payload: false
         })
         const products = response[0]?.data
         pageDispatch({
               type: useCreateProductAction.TABLE_UPDATE_DISPLAY_LIST,
               payload: {
                  list: products?.data,
                  listDefault: products?.data,
                  loading: false
               }
         })
         pageDispatch({
               type: useCreateProductAction.TABLE_UPDATE_PAGINATION,
               payload: {
                  active: Math.ceil(products?.meta?.start / products?.meta?.per_page),
                  amount: products?.meta?.per_page,
                  total: Math.ceil(products?.meta?.total / products?.meta?.per_page),
                  totalItems: products?.meta?.total,
               }
         })
      }
      if (response?.[1]?.data?.success) {
         const digitals = response?.[1]?.data
         pageDispatch({
            type: useModalProductAction.TABLE_UPDATE_DISPLAY_LIST,
            payload: {
               list: digitals?.data,
               listDefault: digitals?.data,
               loading: false
            }
         })
         pageDispatch({
            type: useModalProductAction.TABLE_UPDATE_PAGINATION,
            payload: {
               active: 0,
               amount: digitals?.meta?.per_page,
               total: Math.ceil(digitals?.meta?.total / digitals?.meta?.per_page),
               totalItems: digitals?.meta?.total,
            }
         })
      }

   }
   useEffect(() => {
      getProductList()
   }, [])

   return (
      <Modal
         open={open}
         className={'add-product_modal'}
         onClose={onClose}
      >
         <StyleResultImport>
            <div className={'add-product'}>
               <Text as="p"
                     fontSize={20}
                     fontWeight={600}
                     color={'#2150B7'}
                     style={{textAlign: 'center', width: '100%'}}
               >Cấu hình sản phẩm có thể kinh doanh cho ĐL cấp 2</Text>
               <Text className={"add-product__close"} onClick={onClose}>{GLOBAL_ICONS.close_payment}</Text>
               <div className={'add-product_filter'}>
                  <FilterModalProduct/>
               </div>
               <div className={'add-product_content'}>
                  <ProductTable/>
               </div>
               <div style={{textAlign: 'center', marginTop: 16}}>
                  <Button
                     size={'sm'}
                     onClick={onClose}
                  >Đóng</Button>
               </div>
            </div>
         </StyleResultImport>
      </Modal>
   )
}
const StyleResultImport = styled.div`
   width: 100%;
   height: 100%;
   display: flex;
   align-items: center;
   justify-content: center;
    .add-product{
        position: relative;
        padding: 24px;
        width: 720px;
        height: 80vh;
        background: rgb(255, 255, 255);
        border-radius: 8px;
        &__close{
          position: absolute;
          top: 24px;
          right: 24px;
          cursor: pointer;
        }
        &_filter{
          margin-top: 32px;
        }
        &_content{
          padding-top: 16px;
        }
        &_tabs{
            display: flex ;
            align-items: center;
            margin: 24px 0 32px 0;
            gap: 16px;
        }
         &_tab{
            width: calc(50% - 16px);
            padding: 16px 12px;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            background: rgb(246, 250, 254);
            border: 1px solid rgb(240, 245, 255);
            border-radius: 8px;
        }
      
    }
`